import {
  chartLineBlue,
  chartLineGreen,
} from '@features/lci-report/images/lci-adaptive-synthetic-control';
import { ImageProps } from '@features/powerpoint';

export const controlLine: ImageProps = {
  path: chartLineBlue,
  x: 1,
  y: 3.36,
  w: 11.48,
  h: 3.06,
};

export const exposedLine: ImageProps = {
  path: chartLineGreen,
  x: 1,
  y: 2.34,
  w: 11.48,
  h: 4.06,
};
